export const environment = {
  appName: 'ClassificaOnline',
  envName: 'TEST',
  production: false,
  appVersion: '1.2.0',
  buildVersion: 16,
  authUrl: 'https://apidev.classificaonline.it/v1/login',
  apiUrl: 'https://apidev.classificaonline.it',
  apiVersion: 'v1',
  storagePrefix: 'CLO-',
  primaryColor: '#006FB7',
  appDefaultStringValueData: 'YYYY-MM-DD',
  appDefaultStringValueDataTime: 'YYYY-MM-DD HH:mm',
  appDefaultStringFormatData: 'DD/MM/YYYY',
  appDefaultStringFormatDataTime: 'DD/MM/YYYY HH:mm',
  i18nPrefix: ''
};
